import { ApiRequestPayload, Callback, ExtraAction, apiCall, apiRequestDefaultPayload } from '..';

export const findArticleCategories = (
  successActionName: string,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
) => {
  const apiPath = `/api/crm/articles/categories`;
  console.log(`apiPath`, apiPath);
  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));
  const requestPayload: ApiRequestPayload = {
    ...apiRequestDefaultPayload,
    url: apiPath,
    onSuccess: successActionName,
    customErrors: customErrorList,
    extraActions: extraActions,
    callbacks: callbacks,
  };
  return apiCall(requestPayload);
};
